import { render, staticRenderFns } from "./HourlyTrades.vue?vue&type=template&id=a4057ff4"
import script from "./HourlyTrades.vue?vue&type=script&lang=js"
export * from "./HourlyTrades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports